// Format Date in German format (DD.MM.YYYY)
const formatDEDate = (date?: any) => {
  const actualDate = new Date(date);
  return new Intl.DateTimeFormat('de', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(actualDate);
};

// Format Date and Time in German format (DD.MM.YYYY HH:MM)
const formatDEDateTimeShort = (date?: any) => {
  const actualDateTime = new Date(date);
  return new Intl.DateTimeFormat('de', {
    dateStyle: 'short',
    timeStyle: 'short',
  }).format(actualDateTime);
};

// Format time in German format (HH:MM)
const formatDETimeShort = (date?: any) => {
  const actualTime = new Date(date);
  return new Intl.DateTimeFormat('de', {
    timeStyle: 'short',
  }).format(actualTime);
};

// Format percentage values in German format (e.g. 50%)
const formatPercent = (value?: any) => {
  return new Intl.NumberFormat('de', { style: 'percent' }).format(value);
};

// Format currency values in German format (e.g. 1.000,00 €)
const formatCurrency = (value?: any) => {
  return new Intl.NumberFormat('de-DE', {
    style: 'currency',
    currency: 'EUR',
    maximumSignificantDigits: 1,
  }).format(value);
};

// Custom Translation Formatting for i18n
export const customTranslationFormatting = (value: any, format?: string) => {
  if (format === 'DEDate') {
    return formatDEDate(value);
  }
  if (format === 'DEDateTimeShort') {
    return formatDEDateTimeShort(value);
  }
  if (format === 'DETimeShort') {
    return formatDETimeShort(value);
  }
  if (format === 'percent') {
    return formatPercent(value);
  }
  if (format === 'currency') {
    return formatCurrency(value);
  }
  return value;
};
